import React from 'react'

import { Text } from '@wartek-id/text-v1'
import { Separator } from '@wartek-id/separator'

import { Header } from 'app/KinerjaPage/pages/PelaksanaanV2/components/Header'
import useContentContext from 'app/KinerjaPage/hooks/useContentContext'
import ContentProvider from 'app/KinerjaPage/components/ContentProvider'
import { useAPIKinerjaProfile } from 'api/kinerja/useAPIKinerja'

import type { Jenjang, MultiPeriodParams } from 'types/kinerja'

const PanduanPerilakuKerja = () => {
  const { contentPerilakuKerja } = useContentContext()

  return (
    <div className="px-8 pb-8 pt-12 bg-gray-10 min-h-full">
      <div className="max-w-7xl mx-auto">
        <Header
          backTestId="icon-back"
          className="mb-9"
          title="Indikator dan Perwujudan Perilaku Kerja"
        />

        <div className="mt-12 bg-white rounded-lg">
          <div className="p-9">
            <div className="flex flex-col gap-10">
              {contentPerilakuKerja.aspek.map((aspek, i) => {
                return (
                  <div
                    key={`aspek-${i}`}
                    className="border border-gray-30 rounded p-6"
                  >
                    <div className="flex flex-col gap-6">
                      <div className="flex gap-2.5 items-center">
                        <div className="flex items-center justify-center rounded-full bg-blue-70 w-6 h-6 p-3">
                          <div className="absolute flex">
                            <Text
                              color="inverse"
                              className="!font-bold !text-sm"
                            >
                              {i + 1}
                            </Text>
                          </div>
                        </div>
                        <Text variant="display-sm">{aspek.value}</Text>
                      </div>

                      {aspek.indikator.map((indikator, j, allIndikator) => {
                        return (
                          <React.Fragment key={`indikator-${j}`}>
                            <div className="flex flex-col gap-0.5">
                              <Text color="subdued">Indikator Perilaku</Text>
                              <Text>
                                {i + 1}.{j + 1} {indikator.value}
                              </Text>
                            </div>

                            <div className="flex flex-col gap-0.5">
                              <Text color="subdued">Perwujudan Perilaku</Text>
                              {indikator.ekspektasi.map((ekspektasi, k) => [
                                <Text key={`perwujudan-${k}`}>
                                  {i + 1}.{j + 1}.{k + 1} {ekspektasi.value}
                                </Text>,
                              ])}
                            </div>

                            {j !== allIndikator.length - 1 && <Separator />}
                          </React.Fragment>
                        )
                      })}
                    </div>
                  </div>
                )
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

type PanduanPerilakuKerjaProps = {
  periodParams?: MultiPeriodParams
}
const WrappedPanduanPerilakuKerja = ({
  periodParams,
}: PanduanPerilakuKerjaProps) => {
  const { data: responseGetKinerjaProfile } = useAPIKinerjaProfile()

  return (
    <ContentProvider
      jenjang={responseGetKinerjaProfile?.data.jenjang as Jenjang}
      periodParams={periodParams}
    >
      <PanduanPerilakuKerja />
    </ContentProvider>
  )
}

export default WrappedPanduanPerilakuKerja
